import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MainDataModels } from 'src/app/models/maindata-models';
import { ObjektDataService } from 'src/app/services/objekt-data.service';

@Component({
  selector: 'app-meine-aufgaben-detail-view',
  templateUrl: './meine-aufgaben-detail-view.component.html',
  styleUrls: ['./meine-aufgaben-detail-view.component.scss']
})
export class MeineAufgabenDetailViewComponent implements OnInit{
  public title?: string = "";
  public createdBy? : string = '';
  public responsible : string = '';
  public object : string = "";
  public description : string = "";
  public accepted : number = 0;

  constructor(@Inject(MAT_DIALOG_DATA) public data: MainDataModels.AufgabeMitBenutzer, public dialogRef: MatDialogRef<MeineAufgabenDetailViewComponent>, private svcObjektData: ObjektDataService) {

  }
  ngOnInit(): void {
    this.svcObjektData.getObjektByID(this.data.aufgabe.objectID).subscribe((val) => {
      this.object = val.description
    })
    if(this.data) {
      this.title = this.data.aufgabe.description;
      this.createdBy = this.data.aufgabe.createdBy;
      this.responsible = this.data.aufgabe.responsible;
      this.description = this.data.aufgabe.notes;
      this.accepted = this.data.aufgabe.accepted;
    }
    if(!(this.data as any).position?.top) {
      this.dialogRef.updatePosition({top: "3.75rem"})
    }
  }
}
